export enum MonthNumber {
  Januari = 1,
  Februrary = 2,
  March = 3,
  April = 4,
  May = 5,
  June = 6,
  Juli = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12,
}

export enum FilterType {
  AutoComplete,
  Textbox,
  DateTime,
  Selection,
  LocalDate,
  AutoCompleteMulti,
}
